import { render, staticRenderFns } from "./EntradasDeCompra.vue?vue&type=template&id=16e957f3&"
import script from "./EntradasDeCompra.vue?vue&type=script&lang=js&"
export * from "./EntradasDeCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports